import React, { useState, useEffect, Suspense, startTransition } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import LoadingSpinnerWithBackground from './components/LoadingSpinnerWithBackground';

import { adminRoutes } from './routes/adminRoutes';
import { userRoutes } from './routes/userRoutes';
import { productRoutes } from './routes/productRoutes';
import { basicRoutes } from './routes/basicRoutes';


function App() {
  // Combine all the routes
  const allRoutes = [...basicRoutes, ...adminRoutes, ...userRoutes, ...productRoutes];
  const [loading, setLoading] = useState(true);


  
  useEffect(() => {
    // Simulate data fetching or other loading
    const timer = setTimeout(() => {
      // Use startTransition for smoother state change
      startTransition(() => {
        setLoading(false);
      });
    }, 3000); // Simulate a 3-second loading period; adjust as needed

    return () => clearTimeout(timer); // Cleanup timer
  }, []);


  return (
    <Router>
      <ScrollToTop />
      <div className="relative bg-gray-50 overflow-hidden">
        {/* Conditionally render loading screen or main content */}
        {loading ? (
          <LoadingSpinnerWithBackground setLoading={setLoading} />
        ) : (
          // Use Suspense to show a fallback loading state for lazy-loaded components
          <Suspense fallback={<LoadingSpinnerWithBackground setLoading={setLoading} />}>
            <Routes>
              {allRoutes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
            </Routes>
          {/* Catch-all route for non-existent paths */}
          {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
          </Suspense>
        )}
      </div>
    </Router>
  );
}

export default App;


// landing page component structure

// src/
// |-- components/
// |   |-- Navbar.js
// |   |-- HeroSection.js
// |   |-- TrustedBy.js
// |   |-- FeatureSection.js
// |   |-- StatsSection.js
// |   |-- CTASection.js
// |   |-- Footer.js
// |-- App.js
